import { getEcomProxyEndpoint } from 'product-personalizer/src/utils/config';

import { PreviewAssetAPI, PreviewConfigList } from './PreviewAssetAPI';

const previewAssetAPIEmbedded: PreviewAssetAPI = {
  fetchAssets: (productUid: string) => {
    return fetch(`${getEcomProxyEndpoint()}/product/preview/assets?productUid=${productUid}`).then(
      (response) => response.json() as Promise<PreviewConfigList>,
    );
  },
};

export default previewAssetAPIEmbedded;
